import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App.tsx";
import { ConnectivityBanner } from "./shell/ConnectivityBanner";
import { bootNative } from "./native/boot";
import "./index.css";

// APP-NATIVE-01: a no-op in the browser; in the iPhone / iPad app it opens on /m.
bootNative();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30s default freshness
      refetchOnWindowFocus: false,
      refetchOnReconnect: true, // refetch when the browser regains connectivity
      retry: 3, // ride out a brief blip with exponential backoff
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 15000),
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConnectivityBanner />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
